import React from "react";
import logo from "../assets/flaskLogo.png";
import { Switch, Route, useRouteMatch, Link, NavLink } from "react-router-dom";
import { Accordion, Card } from "react-bootstrap";

const AppSupport = () => {
  let { path, url } = useRouteMatch();

  return (
    <main className="container" style={{ fontFamily: "Trebuchet MS" }}>
      <h1 className="display-4 text-success">Mobile App help</h1>
      <div className="row">
        <div className="col-3">
          <ul className="list-group list-group-flush">
            <Link to={`${url}`} className="app-help-list-item">
              Overview
            </Link>
            <NavLink to={`${url}/account`} className="app-help-list-item">
              Account Management
            </NavLink>
            <NavLink to={`${url}/summary`} className="app-help-list-item">
              Summary Page
            </NavLink>
            <NavLink to={`${url}/live`} className="app-help-list-item">
              Live Data
            </NavLink>
            <NavLink to={`${url}/notifications`} className="app-help-list-item">
              Notifications
            </NavLink>
            <NavLink to={`${url}/comments`} className="app-help-list-item">
              Production Comments
            </NavLink>
          </ul>
        </div>
        <div className="col-9">
          <Switch>
            <Route path={`${path}/account`} component={AccountManagement} />
            <Route path={`${path}/summary`} component={Summary} />
            <Route path={`${path}/live`} component={LiveData} />
            <Route path={`${path}/notifications`} component={Notifications} />
            <Route path={`${path}/comments`} component={ProductionComments} />
            <Route path={`${path}/`} exact component={Overview} />
          </Switch>
        </div>
      </div>
    </main>
  );
};

const Overview = () => {
  return (
    <section>
      <h1>Mobile App Overview</h1>
      <p>
        The Mobile App can be downloaded for both Android and iOS on the public
        app stores. The name of the app is FTR and has the following icon:
      </p>
      <div className="d-flex justify-content-center">
        <img
          src={logo}
          className="img-fluid"
          alt="app-icon"
          style={{ maxWidth: "120px" }}
        />
      </div>
      <p>
        To get an account, you must request one through the application
        administrators or the Service Desk. You must specify why you need to
        access the system and what sites you require access to.
      </p>
      <p>
        The Mobile Apps main function is to display data, and is primary a
        read-only tool. It handles display of both summary data and live data
        under separate tabs.
      </p>
    </section>
  );
};

const AccountManagement = () => {
  return (
    <section>
      <h1>Account Management</h1>
      <Accordion>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Account Setup
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <p>
                The Application does not allow users to sign themselves up, as
                it is an internal business tool.
              </p>
              An account can be setup by administrators only:
              <ul>
                <li>Contact the Service Desk with Access and Site Details</li>
                <li>Reset your password using the emailed link</li>
                <li>Login with your email and new password</li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="1">
            Forgot Password
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              you can request a password reset link from the login Page
              <ul>
                <li>
                  Tap the <strong>Forgot Password</strong> button below the
                  login area
                </li>
                <li>Enter the email associated with your account</li>
                <li>Use the emailed link to reset your password</li>
                <li>Login to your account using the link</li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="2">
            Account Locked
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              you can request a password reset link from the login Page if you
              account is locked.
              <ul>
                <li>
                  Tap the <strong>Forgot Password</strong> button below the
                  login area
                </li>
                <li>Enter the email associated with your account</li>
                <li>Use the emailed link to reset your password</li>
                <li>Login to your account using the link</li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="3">
            Change Password
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              you can change your passwords when logged in:
              <ul>
                <li>
                  Tap the <strong>Menu</strong> tab
                </li>
                <li>
                  Tap the <strong>See your profile</strong> list item
                </li>
                <li>
                  Tap the <strong>Change Password</strong> list item
                </li>
                <li>Enter your old password along with your new password</li>
                <li>An email will confirm the change</li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="4">
            View Permissions
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="4">
            <Card.Body>
              you can see what app permissions you have on your profile:
              <ul>
                <li>
                  Tap the <strong>Menu</strong> tab
                </li>
                <li>
                  Tap the <strong>See your profile</strong> list item
                </li>
                <li>Scroll to the bottom of the page</li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </section>
  );
};

const Summary = () => {
  return (
    <section>
      <h1>Summary Screens</h1>
      <Accordion>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            All Sites
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              Sites are displayed side by side in each screen, and are displayed
              alphabetically. <strong>Swipe</strong> left and right to see other
              sites data.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="1">
            Individual Sites
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              Individual sites display all *All Sites* screens, along with
              bespoke screens aligned to APUs.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="2">
            Seeing more detail
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              Any data point in the list can be seen in more detail.
              <ul>
                <li>
                  <strong>Tap</strong> the card to do so
                </li>
                <li>
                  <strong>Time Periods</strong> are displayed in a{" "}
                  <strong>swipeable list</strong>
                </li>
                <li>
                  <strong>Related Codes</strong> are displayed below this in
                  another <strong>swipeable list</strong>
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="3">
            Requesting Changes
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              Changes to the screens, or creating new ones, can be done by
              sending requests to site champions. The change will be reviewed by
              the FTR Admins collectively to make a decision on implementing.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </section>
  );
};

const LiveData = () => {
  return (
    <section>
      <h1>Live Data</h1>
      <p>
        This tab displays the most recent factory analysis for live factory
        monitoring.
      </p>
      <Accordion>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Site Selection
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              Your default site is displayed at the top of the screen and is
              based on your current logged in site.
              <ul>
                <li>
                  <stong>Tap</stong> the name to change site
                </li>
              </ul>
              Screens are bespoke to each site
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="1">
            Data Screen
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              Data points are displayed vertically and by default display the
              most recent 3 results.
              <ul>
                <li>
                  <strong>Tap</strong> more (if present) to see the past 24
                  hours of results
                </li>
                <li>
                  <strong>Tap</strong> less to go back to the most recent 3
                </li>
                <li>
                  <strong>Tap</strong> add to chart, to present a chart of the
                  last 24 hours
                </li>
                <li>
                  <strong>Tap</strong> Hide chart (top right) to remove the
                  chart
                </li>
                <li>
                  <strong>Scroll</strong> up and down to view the whole page of
                  data
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="2">
            Subscribing
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              If a bell icon is present in the top right of the data card, you
              can subscribe to that parameter.
              <p>Only non-calculated parameters can be subscribed to.</p>
              <ul>
                <li>
                  <strong>Tap</strong> the bell icon
                </li>
                <li>Complete your subscription preferences</li>
              </ul>
              Subscriptions can be managed in the <strong>More</strong> tab.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="3">
            Requesting Changes
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              Changes to the screens, or creating new ones, can be done by
              sending requests to site champions. They will review and implement
              the change.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </section>
  );
};

const Notifications = () => {
  return (
    <section>
      <h1>Notifications</h1>
      <p>
        Central hub for all internal notifications. By default any notification
        raised will be placed in here.
      </p>
      <p>A counter of unread notifications will appear in the tab bar.</p>
      <p>
        Notifications will only be sent if you have subscribed to parameters.
        See Live Data help section for more information.
      </p>
      <Accordion>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Reading Notifications
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <ul>
                <li>
                  <strong>Tap</strong> the notification. This will give you more
                  detail on the parameter; or
                </li>
                <li>
                  <strong>Swipe</strong> to the right, and tap the eye icon
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="1">
            Deleting Notifications
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <ul>
                <li>
                  <strong>Swipe</strong> to the left, and tap the bin icon.
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="2">
            Manage Subscriptions
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              Subscriptions can be modified to change preferences such as email
              or push notifications.
              <ul>
                <li>
                  Go to <strong>Menu</strong> tab
                </li>
                <li>
                  <strong>Tap</strong> Manage Subscriptions
                </li>
                <li>
                  <strong>Tap</strong> the subscription you wish to modify
                </li>
                <li>
                  <strong>Tap</strong> update to save changes.
                </li>
              </ul>
              subscriptions can also be removed
              <ul>
                <li>
                  Go to <strong>Menu</strong> tab
                </li>
                <li>
                  <strong>Tap</strong> Manage Subscriptions
                </li>
                <li>
                  <strong>Swipe</strong> to the left on the subscription you
                  wish to delete
                </li>
                <li>
                  <strong>Tap</strong> bin icon to remove.
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="3">
            Requesting Changes
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="3">
            <Card.Body></Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </section>
  );
};

const ProductionComments = () => {
  return (
    <section>
      <h1>Production Comments</h1>
      <p>
        Submitting comments requires permissions set on your profile. These can
        be given by a site champion
      </p>
      <p>
        Comments automatically gets your current logged in site, and username to
        for the post.
      </p>
      <p>Todays comments are displayed below the input box.</p>
    </section>
  );
};

export default AppSupport;
